module.exports = __webpack_public_path__ + "img/txt.cdc57e93.svg";